export const OptionList = ({ options, value, onChange, testIdPrefix }) => (
  <div className="mt-8 border-t border-foreground">
    {options.map((opt, i) => {
      const selected = value === i;
      return (
        <label
          key={i}
          data-testid={`${testIdPrefix}-option-${i}`}
          className={`group flex items-start gap-4 px-3 py-4 cursor-pointer border-b transition-colors duration-100 ${
            selected ? "border-b-foreground bg-signal/10" : "border-b-foreground/20 hover:bg-foreground/[0.04]"
          }`}
        >
          <input type="radio" className="sr-only" checked={selected} onChange={() => onChange(i)} />
          <div className={`mt-0.5 w-7 h-7 flex items-center justify-center font-mono-fig text-xs font-bold shrink-0 border ${
            selected ? "bg-signal border-signal text-ink" : "border-foreground text-foreground group-hover:bg-foreground group-hover:text-background"
          }`}>
            {String.fromCharCode(65 + i)}
          </div>
          <div className={`text-base leading-relaxed ${selected ? "text-foreground font-medium" : "text-foreground/85"}`}>
            {opt}
          </div>
        </label>
      );
    })}
  </div>
);

export const TextAnswer = ({ value, onChange, number, autoFocus = true }) => (
  <div className="mt-6">
    <label className="overline" htmlFor={`gap-${number}`}>Your answer for gap {number}</label>
    <input
      id={`gap-${number}`}
      autoFocus={autoFocus}
      autoComplete="off"
      spellCheck={false}
      maxLength={40}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={autoFocus ? "test-text-answer-input" : `test-text-answer-input-${number}`}
      placeholder="Type here…"
      className="neu-input w-full mt-3 px-5 py-4 text-lg"
    />
    <p className="mt-3 text-xs text-muted-foreground">Spelling counts. Capital letters don't matter.</p>
  </div>
);

export const WordCount = ({ text, min, target, testId }) => {
  const words = (text.trim().match(/[A-Za-z']+/g) || []).length;
  return (
    <div className="mt-3 flex items-center justify-between text-sm">
      <div className={`font-mono-fig font-bold ${words >= min ? "text-foreground" : "text-[#c25e00] dark:text-signal"}`} data-testid={testId}>
        {words} words <span className="text-muted-foreground">/ target ~{target}</span>
      </div>
      <div className="text-xs text-muted-foreground">Minimum: {min} words</div>
    </div>
  );
};
